export default "../media/bg_thinking_large.26cbebf30a793865db2449276148e24c.jpeg";